import { AppState } from 'Src/store'
import { createSelector } from '@reduxjs/toolkit'

const selectList = (state: AppState) => state.adminSlice.serviceNotifications.list
const selectRequestParams = (state: AppState) => state.adminSlice.serviceNotifications.requestParams
const selectItem = (state: AppState) => state.adminSlice.serviceNotifications.item
const selectIsLoading = (state: AppState) => state.adminSlice.serviceNotifications.isLoading
const selectServiceNotificationsList = (state: AppState) =>
	state.adminSlice.serviceNotifications.list.entries
const selectTotal = createSelector(selectList, (list) => list.total_entries)
const selectActiveServiceNotificationsList = (state: AppState) =>
	state.adminSlice.serviceNotifications.activeList.entries

export const serviceNotificationsSelectors = {
	selectRequestParams,
	selectItem,
	selectIsLoading,
	selectList,
	selectServiceNotificationsList,
	selectTotal,
	selectActiveServiceNotificationsList,
}
